import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ChecklistNodeCheckpoint} from "../model/checklist-node-checkpoint";
import {ChecklistsService} from "../../../../common/services/checklists.service";
import {Localization} from "../../../../common/enums/localization";
import {ConfirmationDialogModel, DialogService} from "@npm.chapps.com/chapps.common.angular.library";
import {TranslateService} from "@ngx-translate/core";
import {take} from "rxjs/operators";
import {MDBModalService} from "ng-uikit-pro-standard";
import {EditNodeModalComponent} from "../../components/edit-node-modal/edit-node-modal.component";
import {
  AddUpdateCheckpointModalComponent
} from "../../components/add-update-checkpoint-modal/add-update-checkpoint-modal.component";

@Component({
  selector: 'app-checklist-checkpoint',
  templateUrl: './checklist-checkpoint.component.html',
  styleUrls: ['./checklist-checkpoint.component.scss']
})
export class ChecklistCheckpointComponent implements OnInit {
  public readonly Localization = Localization;

  @Input()
  public checkpoint: ChecklistNodeCheckpoint;

  @Input()
  public readOnly = false;

  @Output()
  public readonly onDelete = new EventEmitter<ChecklistNodeCheckpoint>();
   @Output()
  public readonly onDuplicate = new EventEmitter<[ChecklistNodeCheckpoint, ChecklistNodeCheckpoint]>();

  public saving = false;
  constructor(
      private readonly checklistsService: ChecklistsService,
      private readonly dialogs: DialogService,
      private readonly translate: TranslateService,
      private readonly dialogService: MDBModalService,

  ) { }

  ngOnInit(): void {
  }

  public async save() {
    this.saving = true;
    await this.checklistsService.updateChecklistNodeCheckpoint(this.checkpoint).toPromise();
    this.saving = false;
  }

  public async toggleMandatory() {
    this.checkpoint.mandatory = !this.checkpoint.mandatory;
    await this.save();
  }


  private confirmDelete() {
      return this.dialogs.confirm(ConfirmationDialogModel.create({
        title: 'delete',
        text: this.translate.instant(Localization.AreYouSureYouWantToDelete, {value: this.checkpoint.checkPoint.label}),
        confirmText: Localization.Delete,
      })).pipe(take(1)).toPromise();
  }

  public async edit() {
    const ref = this.dialogService.show(AddUpdateCheckpointModalComponent, {class: 'modal-dialog-centered'})
    const editDialog = ref.content as AddUpdateCheckpointModalComponent;
    const updatedCheckpoint = await editDialog.show(this.checkpoint.templateChecklistNodeId, this.checkpoint.checkPoint);
    if (updatedCheckpoint) {
      this.checkpoint.checkPoint = updatedCheckpoint;
    }

  }

  public async duplicate() {
    const duplicate = await this.checklistsService.duplicateNewCheckpoint(this.checkpoint).toPromise();
    this.onDuplicate.emit([duplicate as unknown as ChecklistNodeCheckpoint, this.checkpoint]);
  }

  public async attemptDelete() {
    const confirmedDelete = await this.confirmDelete();
    if (confirmedDelete) {
      await this.checklistsService.deleteNodeCheckpoint(this.checkpoint.id).toPromise();
      this.onDelete.emit(this.checkpoint);
    }
  }
}
